import React from "react";

const HajjGroupAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Hero / Header Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                display: "block",
                textTransform: "uppercase",
              }}
            >
              ✦ TRUSTED HAJJ & UMRAH SERVICES
            </span>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Guiding Your Spiritual Journey with{" "}
              <span style={{ color: brandPurple }}>Excellence & Care</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>Iconic Hajj Group</strong>{" "}
              provides trusted Hajj and Umrah services designed to make every
              spiritual journey comfortable, organized, and deeply meaningful.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              With dedicated Islamic scholars, premium hotel arrangements near
              Haram Sharif, direct flight bookings, and end-to-end ground
              transport, we ensure complete peace of mind for every pilgrim.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "Government Approved Hajj Agency",
                "5-Star & 3-Star Proximity Hotels",
                "Experienced Scholar Guidance",
                "Dedicated Ground Coordination",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://i.pinimg.com/736x/17/6c/25/176c2509e85b5560abe96773b4926ea3.jpg"
              alt="Makkah Holy Kaaba Pilgrimage"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                10,000+
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Pilgrims Served
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Key Metrics Bar ================= */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            padding: "32px 24px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "10,000+", label: "Pilgrims Served" },
            { value: "100%", label: "Sunnah Compliant" },
            { value: "12+ Yrs", label: "Hajj Experience" },
            { value: "24/7", label: "Makkah & Madinah Support" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. Services Grid ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              OUR PILGRIMAGE PACKAGES
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Dedicated Hajj & Umrah{" "}
              <span style={{ color: brandCyan }}>Services</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
            }}
          >
            {[
              {
                title: "VIP Executive Hajj Packages",
                desc: "Premium accommodation close to Haram, luxury transport, VIP Mina/Arafat tent facilities, and personalized guidance.",
              },
              {
                title: "Customized Umrah Packages",
                desc: "Year-round Umrah packages tailored to your schedule with flexible stay duration in Makkah and Madinah.",
              },
              {
                title: "Scholarly Guidance & Workshops",
                desc: "Pre-departure training seminars and step-by-step guidance during rituals by authentic Islamic scholars.",
              },
              {
                title: "Makkah & Madinah Ziyarah",
                desc: "Guided historical tours to holy sites (Ziyarah) in private AC buses with expert multilingual guides.",
              },
              {
                title: "Visa Processing & Flights",
                desc: "Hassle-free Umrah/Hajj visa assistance, direct flight ticketing, and complete documentation support.",
              },
              {
                title: "Family & Group Packages",
                desc: "Special group discounts, family suite options, and dedicated assistance for elderly pilgrims.",
              },
            ].map((service, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "26px 22px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 4. Highlight Banner ================= */}
        <div
          style={{
            background: "#fdf4ff",
            border: "1px solid #f5d0fe",
            padding: "40px",
            borderRadius: "16px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              HOLY LAND CARE
            </span>
            <h3
              style={{
                fontSize: "26px",
                fontWeight: "800",
                color: "#0f172a",
                margin: "8px 0 12px 0",
              }}
            >
              Unmatched Convenience & Comfort
            </h3>
            <p
              style={{
                fontSize: "15px",
                color: "#475569",
                lineHeight: "1.65",
                margin: 0,
              }}
            >
              We handle all logistics so you can focus entirely on your Ibadah.
              From airport pickup in Jeddah/Madinah to authentic
              Bengali/international catering, our team stays by your side
              throughout the journey.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {[
              { title: "Close to Haram", desc: "Walking distance hotels" },
              {
                title: "Buffet Catering",
                desc: "Hygienic & healthy meal options",
              },
              { title: "AC Transport", desc: "Private modern intercity buses" },
              { title: "24/7 Helpline", desc: "Local Saudi ground assistance" },
            ].map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "18px 16px",
                  borderRadius: "10px",
                  border: "1px solid #fae8ff",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 4px 0",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: brandPurple,
                  }}
                >
                  {item.title}
                </h4>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    lineHeight: "1.4",
                    display: "block",
                  }}
                >
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Light CTA Banner ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#fff",
              }}
            >
              Plan Your Blessed Journey Today
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Book your upcoming Hajj or Umrah package with Iconic Hajj Group.
            </p>
          </div>

          <button
            style={{
              background: "#ffffff",
              color: "#0f172a",
              border: "none",
              padding: "14px 28px",
              borderRadius: "8px",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            Inquire Package →
          </button>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default HajjGroupAbout;
